// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__X4dZ6","modal":"styles_modal__7TiFL","closeCross":"styles_closeCross__2nBmW"};